<template>
  <div
    class="text-justify"
  >
    <div v-if="text.length > 100">
      <p class="p" v-if="!readMore">
        {{ text.slice(0,100) }}
        <span
          class="text-info cursor-pointer"
          @click="changeReamMoreStatus()"
        >
          ...leer más
        </span>
      </p>
      <p class="p" v-if="readMore">
        {{ text }}
        <span
          class="text-info cursor-pointer"
          @click="changeReamMoreStatus()"
      >
        ...leer menos
      </span>
      </p>
    </div>
    <div v-if="text.length <= 100">
      {{ text }}
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      readMore: false,
    };
  },
  props: [
    'text'
  ],
  methods: {
    changeReamMoreStatus() {
      this.readMore = !this.readMore;
    },
  }
};
</script>

<style>
.cursor-pointer {
  cursor: pointer;
}
</style>
